import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { isDefined } from '@sgme/fp';

import type { WebapiEndpointBuilder } from '@/api/webapi.ts';

export type GetEspTieringParams = {
  clientId: number;
  currencyPair: string;
  spotDate: string;
  // Paramètre optionnel pour indiquer si c'est un retry
  isRetry?: boolean;
};

export type GetEspTieringResponse =
  | {
      tiering: string;
      isDefaultTiering: boolean; // Indicates if this is the default tiering (clientId = 0)
    }
  | {
      error: FetchBaseQueryError;
    };

export const getEspTiering = (builder: WebapiEndpointBuilder) => {
  return builder.query<GetEspTieringResponse, GetEspTieringParams>({
    queryFn: async (params, _api, _extraOptions, baseQuery) => {
      const tieringForClientId = await baseQuery({
        url: `/fxSpotFwd/esp/tieringV3/${params.clientId}/spot/${params.currencyPair}/${params.spotDate}`,
        method: 'GET',
      });

      if (isDefined(tieringForClientId.error)) {
        return { error: tieringForClientId.error };
      }

      const { tieringId: tiering, isDefault: isDefaultTiering } = JSON.parse(tieringForClientId.data as string) as {
        tieringId: string;
        isDefault: boolean;
      };

      return {
        data: {
          tiering,
          isDefaultTiering,
        },
      };
    },
  });
};
